<!--搜索框 和 用户状态栏-->
<template>
  <div class="headerClass">
    <div class="container">
      <div class="header-left">
        <img src="../../assets/logo.png" alt class="logoImg" />
        <div class="routerDiv">
          <a href="/" class="routerLabel">首页</a>
          <a v-show="userInfo!=null"  @click="ProjectJump()" class="routerLabel">全景图片</a>
          <a  v-show="userInfo!=null" @click="ManagerJump()" class="routerLabel">素材管理</a>
        </div>
      </div>
      <div class="header-right">
        <div class="searchDiv">
          <input type="text" placeholder="搜索" class="searchInput" />
          <img src="../../assets/icon/icon_search.gif" alt class="searchImg" @click="searchBtn()" />
        </div>
        <div v-show="userInfo!=null" class="publish" @click="newProject">
          <img src="../../assets/icon/cloud.png" alt class="publishIcon" />
          <label class="publishLabel">发布</label>
        </div>
        <div class="userDiv">
          <label v-if="userInfo==null" class="userLabel" @click="LoginJump()">登录/注册</label>
          <label v-else class="userLabel" @click="showUserLine()">{{userInfo.account}}</label>
        </div>
        <div class="userlineDiv">
          <div class="lineItem">账户管理</div>
          <div class="lineItem">个人主页</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerC",
  mounted() {
   this.userInfo =JSON.parse( sessionStorage.getItem("userInfo"))
  //  console.log(this.userInfo);
  },
  data() {
    return {
      userInfo:null
    };
  },
  methods: {
    searchBtn() {
      this.$http.get("/api/index").then((res) => {
        console.log(res);
      });

      console.log("搜索按钮被点击了");
    },
    showUserLine() {
      if (
        document.querySelector(".userlineDiv").style.display === "none" ||
        document.querySelector(".userlineDiv").style.display === ""
      ) {
        document.querySelector(".userlineDiv").style.display = "block";
      } else {
        document.querySelector(".userlineDiv").style.display = "none";
      }
    },
    LoginJump(){
      this.$router.push("/Login");
    },
    newProject() {
      if (this.$route.path !== "/Publish") {
        this.$router.push("/Publish");
      }
    },
    ProjectJump(){
      if (this.$route.path !== "/ProjectList") {
        this.$router.push("/ProjectList");
      }
    },
    ManagerJump(){
      if (this.$route.path !== "/ManagerView") {
        this.$router.push("/ManagerView");
      }
    },
  },
};
</script>

<style scoped>
.headerClass {
  background-color:#F7F7F7;
  width: 100%;
  height: auto;
}
.container{
  display: flex;
  justify-content: space-between; /* 根据需要控制元素对齐 */
  align-items: center;
  width: 100%;
  max-width: 1500px;
  height: 40px;
  padding: 0 15px;
  margin: 0 auto;
}
.header-left{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.header-right{
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.routerLabel{
  margin: auto 15px;
  color: #000;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
}
.logoImg {
  width: 100px;
  height: 40px;
}
.searchDiv{
  width: 200px;
  height: 35px;
  background-color: #fff;
  border-radius: 17px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.searchInput{
  border: none;
  outline: none;
  padding: 0% 10px;
  width:70%;
}
.publish{
  background-color: #4CAF50;
  width: 80px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.publish:hover{
  background-color: #3e8e41;
  opacity: 0.8; /* 鼠标移上去时透明度降低 */

}
.searchImg:hover {
  transform: scale(1.1);
  opacity: 0.8; /* 鼠标移上去时透明度降低 */
  cursor: pointer;
}
.publishIcon{
  color: #fff;
}
.publishLabel{
  color: #fff;
  font-size: 14px;
}
.userLabel{
  font-size: 14px;
  color: #000;
  margin-left: 10px;
  cursor: pointer;
}
.userlineDiv {
  z-index: 99;
  display: none;
  position: absolute;
  right: -40px;
  top: 43px;
  width:150px; /* 确保宽度使用百分比 */
  /* height: 30px; */
  background-color: #fff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1); /* 更自然的阴影 */
  border-radius: 4px; /* 添加圆角 */
}
.lineItem{
  padding: 10px 10px;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
}
</style>
